import Header from '../components/global/header'
import Footer from '../components/global/footer'
import PrimaryButton from '../components/global/PrimaryButton'

export default function About() {
    return (
      <>
      <Header />
      <section className="relative overflow-hidden py-20">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full blur-[100px] opacity-25 pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, #0ea5e9 0%, #06b6d4 40%, transparent 70%)' }} />
        <div className="mx-auto max-w-5xl px-6 relative">
          <div className="glass-strong rounded-[28px] p-8 lg:p-12 flex flex-col lg:flex-row items-center gap-10">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img src="/error.png" alt="Error illustration" className="max-w-[360px] w-full rounded-2xl" />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] text-sky-300 font-medium"><span className="w-1.5 h-1.5 rounded-full bg-sky-400" /> 404</div>
              <h1 className="mt-3 text-[28px] lg:text-[32px] font-semibold tracking-tight text-white leading-tight">Looks like you&apos;ve found the doorway to the great nothing</h1>
              <p className="py-3 text-[15px] leading-6 text-white/55">The content you&apos;re looking for doesn&apos;t exist. Either it was removed, or you mistyped the link.</p>
              <p className="py-1 text-[15px] leading-6 text-white/55">Sorry about that. Please visit our homepage to get where you need to go.</p>
              <div className="mt-6">
                <PrimaryButton as="a" href="/">Go back to homepage</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      </>
    );
  }
